// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bp-root {
  --bp-bg: rgba(0, 0, 0, 0.7);
  --bp-panel: rgba(16, 16, 16, 0.96);
  --bp-panel-soft: rgba(255, 255, 255, 0.05);
  --bp-border: rgba(255, 255, 255, 0.1);
  --bp-text-main: #f2f2f2;
  --bp-text-muted: #a6a6a6;
  --bp-accent: #ffcc00;
  --bp-accent-2: #f59e0b;
  position: fixed;
  inset: 0;
  z-index: 1900;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bp-bg);
  color: var(--bp-text-main);
  font-family: 'TT Commons', sans-serif;
}
.bp-root *,
.bp-root *::before,
.bp-root *::after {
  box-sizing: border-box;
}
.bp-root button,
.bp-root [type="button"],
.bp-root .bp-card,
.bp-root .bp-page-dot,
.bp-root .bp-page-nav {
  outline: none !important;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
}
.bp-root button:focus,
.bp-root button:focus-visible,
.bp-root .bp-card:focus,
.bp-root .bp-card:focus-visible,
.bp-root .bp-page-dot:focus,
.bp-root .bp-page-dot:focus-visible,
.bp-root .bp-page-nav:focus,
.bp-root .bp-page-nav:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.bp-backdrop {
  position: absolute;
  inset: 0;
}
.bp-shell {
  width: 78vw;
  height: 76vh;
  background: var(--bp-panel);
  border-radius: 12px;
  border: 1px solid var(--bp-border);
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);
  padding: 0.75vw;
  display: flex;
  flex-direction: column;
  gap: 0.6vw;
  overflow: hidden;
  position: relative;
}
.bp-header {
  min-height: 5.1vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1vw;
  border-bottom: 1px solid var(--bp-border);
  padding-bottom: 0.35vw;
}
.bp-header h1 {
  margin: 0;
  font-size: 2.15vw;
  line-height: 1;
  font-weight: 900;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.bp-days {
  color: var(--bp-text-muted);
  font-size: 1.25vw;
  font-weight: 800;
  text-transform: uppercase;
  white-space: nowrap;
}
.bp-days span {
  color: var(--bp-accent);
  font-weight: 900;
}
.bp-season-progress {
  border: 1px solid var(--bp-border);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
  padding: 0.45vw 0.6vw;
}
.bp-season-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1vw;
  margin-bottom: 0.28vw;
  color: var(--bp-text-muted);
  font-size: 0.75vw;
  font-weight: 800;
  text-transform: uppercase;
}
.bp-season-value {
  color: var(--bp-text-main);
}
.bp-season-track {
  width: 100%;
  height: 0.78vh;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  overflow: hidden;
}
.bp-season-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--bp-accent), var(--bp-accent-2));
}
.bp-content {
  display: grid;
  grid-template-columns: 1.75fr 0.95fr;
  gap: 0.6vw;
  min-height: 15.5vh;
  height: 15.5vh;
  align-items: stretch;
}
.bp-selected,
.bp-actions,
.bp-track-wrapper {
  border: 1px solid var(--bp-border);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.02);
}
.bp-selected {
  display: grid;
  grid-template-columns: 7.2vw 1fr;
  gap: 0.82vw;
  padding: 0.5vw;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}
.bp-selected-image {
  width: 100%;
  height: 100%;
  border-radius: 0;
  overflow: visible;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.bp-selected-image img {
  max-width: 76%;
  max-height: 76%;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
  display: block;
  margin: 0 auto;
}
.bp-selected-info {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.36vw;
  padding-top: 0.08vw;
}
.bp-selected-title {
  font-size: 1.78vw;
  font-weight: 900;
  line-height: 1.02;
  max-width: 100%;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.bp-selected-detail {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.16vw;
  color: var(--bp-text-main);
  font-size: 0.82vw;
  font-weight: 700;
  line-height: 1.28;
  overflow: auto;
  padding-right: 0.22vw;
  scrollbar-width: none;
}
.bp-selected-detail.density-compact {
  gap: 0.12vw;
  font-size: 0.75vw;
  line-height: 1.2;
}
.bp-selected-detail.density-tight {
  gap: 0.08vw;
  font-size: 0.68vw;
  line-height: 1.12;
}
.bp-selected-detail-line {
  white-space: normal;
}
.bp-selected-detail-line.is-empty {
  min-height: 0.6em;
}
.bp-selected-detail::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.bp-selected-placeholder {
  color: var(--bp-text-muted);
  font-size: 0.76vw;
  font-weight: 700;
  line-height: 1.2;
}
.bp-selected-points {
  font-size: 1.42vw;
  font-weight: 800;
  color: var(--bp-accent);
  line-height: 1;
}
.bp-badge {
  width: fit-content;
  max-width: 100%;
  padding: 0.22vw 0.65vw;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.72vw;
  font-weight: 900;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bp-badge.state-claim {
  color: #ffd8ff;
  background: rgba(217, 102, 255, 0.22);
  border-color: rgba(217, 102, 255, 0.45);
}
.bp-badge.state-done {
  color: #ceffd6;
  background: rgba(76, 175, 80, 0.22);
  border-color: rgba(76, 175, 80, 0.45);
}
.bp-badge.state-vip {
  color: #ffe0b0;
  background: rgba(255, 159, 26, 0.22);
  border-color: rgba(255, 159, 26, 0.5);
}
.bp-badge.state-open {
  color: #ffe7ab;
  background: rgba(255, 204, 0, 0.2);
  border-color: rgba(255, 204, 0, 0.45);
}
.bp-badge.state-locked {
  color: #d8d8d8;
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}
.bp-actions {
  display: flex;
  flex-direction: column;
  gap: 0.35vw;
  padding: 0.5vw;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}
.bp-actions-title {
  color: var(--bp-text-muted);
  font-size: 0.72vw;
  font-weight: 800;
  text-transform: uppercase;
}
.bp-actions-state {
  min-height: 3.4vh;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5vw;
  font-size: 0.92vw;
  font-weight: 900;
  text-transform: uppercase;
  text-align: center;
}
.bp-actions-state.state-claim {
  color: #ffd8ff;
  border-color: rgba(217, 102, 255, 0.5);
  background: rgba(217, 102, 255, 0.22);
}
.bp-actions-state.state-done {
  color: #ceffd6;
  border-color: rgba(76, 175, 80, 0.55);
  background: rgba(76, 175, 80, 0.22);
}
.bp-actions-state.state-vip {
  color: #ffe0b0;
  border-color: rgba(255, 159, 26, 0.6);
  background: rgba(255, 159, 26, 0.24);
}
.bp-actions-state.state-open {
  color: #ffe7ab;
  border-color: rgba(255, 204, 0, 0.6);
  background: rgba(255, 204, 0, 0.22);
}
.bp-btn {
  min-height: 3.35vh;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 0.96vw;
  font-weight: 900;
  text-transform: uppercase;
  cursor: pointer;
}
.bp-btn-placeholder {
  visibility: hidden;
  pointer-events: none;
}
.bp-btn-primary {
  background: linear-gradient(135deg, #ffcc00 0%, #f59e0b 100%);
  color: #1a1a1a;
  border-color: rgba(255, 204, 0, 0.5);
}
.bp-btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  color: var(--bp-text-main);
  border-color: rgba(255, 255, 255, 0.22);
}
.bp-track-wrapper {
  flex: 1;
  min-height: 0;
  padding: 0.45vw;
  display: flex;
  flex-direction: column;
  gap: 0.38vw;
}
.bp-track {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 0.42vw;
  overflow: hidden;
}
.bp-card {
  flex: 0 0 calc((100% - 1.68vw) / 5);
  width: calc((100% - 1.68vw) / 5);
  min-width: 0;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--bp-border);
  border-radius: 8px;
  padding: 0.38vw;
  display: flex;
  flex-direction: column;
  gap: 0.24vw;
  position: relative;
  text-align: left;
  color: var(--bp-text-main);
  cursor: pointer;
  overflow: hidden;
}
.bp-card.is-selected {
  border-color: rgba(255, 204, 0, 0.8);
  background: rgba(255, 204, 0, 0.08);
}
.bp-card-pass-tag {
  position: absolute;
  top: 0.3vw;
  right: 0.3vw;
  min-height: 1.5vh;
  padding: 0 0.32vw;
  border-radius: 999px;
  background: rgba(255, 159, 26, 0.92);
  color: #171717;
  font-size: 0.45vw;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bp-card-level {
  width: fit-content;
  max-width: calc(100% - 2.8vw);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 0.18vw;
  padding: 0.16vw 0.34vw;
  text-transform: uppercase;
}
.bp-card-level-label {
  opacity: 0.72;
  font-size: 0.46vw;
  font-weight: 800;
}
.bp-card-level-number {
  font-size: 0.62vw;
  font-weight: 900;
  line-height: 1;
}
.bp-card-image {
  flex: 0 0 auto;
  width: 82%;
  aspect-ratio: 1 / 1;
  min-height: 0;
  border-radius: 0;
  overflow: visible;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  padding: 0;
  margin: 0 auto;
}
.bp-card-image img {
  max-width: 76%;
  max-height: 76%;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
  display: block;
  margin: 0 auto;
}
.bp-card-title {
  font-size: 0.84vw;
  font-weight: 800;
  line-height: 1.06;
  min-height: 3.18em;
  max-height: 3.18em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.bp-card-status {
  color: var(--bp-text-muted);
  font-size: 0.62vw;
  text-transform: uppercase;
  line-height: 1.05;
  min-height: 0;
  overflow: hidden;
}
.bp-card-track {
  width: 100%;
  height: 0.65vh;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  overflow: hidden;
}
.bp-card-track div {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #ffcc00, #f59e0b);
}
.bp-card.state-claim .bp-card-track div {
  background: linear-gradient(90deg, #d966ff, #f1b8ff);
}
.bp-card.state-done .bp-card-track div {
  background: linear-gradient(90deg, #4caf50, #81db84);
}
.bp-card.state-vip .bp-card-track div {
  background: linear-gradient(90deg, #ff9f1a, #ffd08c);
}
.bp-card.state-locked .bp-card-track div {
  background: linear-gradient(90deg, #7e7e7e, #b3b3b3);
}
.bp-card-points {
  font-size: 0.48vw;
  color: #e1e1e1;
  font-weight: 700;
  line-height: 1.12;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bp-pagination {
  min-height: 3.4vh;
  border-top: 1px solid var(--bp-border);
  padding-top: 0.22vw;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45vw;
}
.bp-page-nav {
  width: 1.7vw;
  height: 1.7vw;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  font-size: 0.95vw;
  line-height: 1;
  cursor: pointer;
  flex: 0 0 auto;
}
.bp-page-nav:disabled {
  opacity: 0.35;
  cursor: default;
}
.bp-page-strip {
  min-width: 26vw;
  max-width: 36vw;
  height: 2.15vw;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3vw;
  padding: 0 0.7vw;
  overflow-x: auto;
  scrollbar-width: none;
}
.bp-page-strip::-webkit-scrollbar,
.bp-track::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.bp-page-dot {
  min-width: 1.22vw;
  height: 1.22vw;
  padding: 0 0.26vw;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  background: rgba(255, 255, 255, 0.05);
  color: #d0d0d0;
  font-size: 0.58vw;
  font-weight: 800;
  cursor: pointer;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.bp-page-dot.is-active {
  border-color: rgba(255, 204, 0, 0.8);
  background: #ffcc00;
  color: #151515;
}
@media (min-width: 2560px) and (min-aspect-ratio: 21 / 9) {
  .bp-shell {
    width: 84vw;
    height: 80vh;
    max-height: calc(100vh - 32px);
    padding: 14px;
    gap: 10px;
  }
  .bp-header {
    min-height: 76px;
    padding-bottom: 8px;
  }
  .bp-header h1 {
    font-size: clamp(42px, 1.9vw, 64px);
  }
  .bp-days {
    font-size: clamp(26px, 1.05vw, 38px);
  }
  .bp-season-progress {
    padding: 10px 14px;
  }
  .bp-season-top {
    font-size: clamp(14px, 0.52vw, 20px);
    margin-bottom: 7px;
  }
  .bp-content {
    min-height: 18.2vh;
    height: 18.2vh;
    gap: 10px;
  }
  .bp-selected {
    grid-template-columns: 170px 1fr;
    padding: 12px;
    gap: 12px;
  }
  .bp-selected-image img {
    max-width: 82%;
    max-height: 82%;
  }
  .bp-selected-detail {
    font-size: clamp(14px, 0.48vw, 20px);
    line-height: 1.24;
    gap: 4px;
    padding-right: 8px;
    scrollbar-width: thin;
  }
  .bp-actions {
    padding: 12px;
    gap: 8px;
  }
  .bp-actions-title {
    font-size: clamp(13px, 0.45vw, 18px);
  }
  .bp-actions-state {
    min-height: 58px;
    font-size: clamp(22px, 0.74vw, 32px);
    padding: 0 12px;
  }
  .bp-btn {
    min-height: 58px;
    font-size: clamp(24px, 0.78vw, 34px);
  }
  .bp-track-wrapper {
    padding: 10px;
    gap: 8px;
  }
  .bp-track {
    justify-content: center;
  }
  .bp-card {
    flex: 0 0 320px;
    width: 320px;
    padding: 8px;
    gap: 6px;
  }
  .bp-card-image {
    width: 72%;
    max-width: 180px;
    max-height: 180px;
  }
  .bp-card-track {
    margin-top: auto;
  }
  .bp-card-title {
    font-size: clamp(16px, 0.56vw, 22px);
  }
  .bp-card-status {
    font-size: clamp(11px, 0.38vw, 15px);
  }
  .bp-card-points {
    font-size: clamp(10px, 0.34vw, 14px);
  }
  .bp-pagination {
    min-height: 58px;
    padding-top: 6px;
  }
  .bp-page-nav {
    width: 40px;
    height: 40px;
    font-size: 24px;
  }
  .bp-page-strip {
    height: 48px;
    min-width: 560px;
    max-width: 860px;
    gap: 8px;
    padding: 0 14px;
  }
  .bp-page-dot {
    min-width: 32px;
    height: 32px;
    font-size: 16px;
    padding: 0 8px;
  }
}
@media (max-width: 1280px) {
  .bp-shell {
    width: 88vw;
    height: 80vh;
    padding: 0.85vw;
  }
  .bp-header h1 {
    font-size: 2.8vw;
  }
  .bp-days {
    font-size: 1.6vw;
  }
  .bp-season-top {
    font-size: 1vw;
  }
  .bp-content {
    grid-template-columns: 1.4fr 1fr;
    min-height: 16.5vh;
    height: 16.5vh;
  }
  .bp-selected {
    grid-template-columns: 8.8vw 1fr;
  }
  .bp-selected-title {
    font-size: 2vw;
  }
  .bp-selected-detail {
    font-size: 0.98vw;
  }
  .bp-selected-detail.density-compact {
    font-size: 0.88vw;
  }
  .bp-selected-detail.density-tight {
    font-size: 0.8vw;
  }
  .bp-selected-points {
    font-size: 1.55vw;
  }
  .bp-selected-placeholder,
  .bp-badge,
  .bp-actions-title,
  .bp-actions-state,
  .bp-btn {
    font-size: 0.95vw;
  }
  .bp-card-title {
    font-size: 1vw;
    min-height: 3.18em;
    max-height: 3.18em;
  }
  .bp-card-status {
    font-size: 0.78vw;
  }
  .bp-card-points {
    font-size: 0.62vw;
  }
  .bp-page-dot {
    min-width: 1.9vw;
    height: 1.7vw;
    padding: 0 0.34vw;
    font-size: 0.85vw;
  }
  .bp-page-nav {
    width: 2.2vw;
    height: 2.2vw;
    font-size: 1.25vw;
  }
}
@media (max-width: 980px) {
  .bp-shell {
    width: 94vw;
    height: 86vh;
    padding: 10px;
    gap: 10px;
  }
  .bp-header {
    min-height: 46px;
    padding-bottom: 6px;
  }
  .bp-header h1 {
    font-size: 32px;
  }
  .bp-days {
    font-size: 18px;
  }
  .bp-season-progress {
    padding: 10px 12px;
  }
  .bp-season-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    margin-bottom: 6px;
    font-size: 12px;
  }
  .bp-content {
    grid-template-columns: 1fr;
    height: auto;
  }
  .bp-selected {
    grid-template-columns: 132px 1fr;
    min-height: 130px;
    padding: 10px;
    gap: 10px;
  }
  .bp-selected-title {
    font-size: 24px;
    white-space: normal;
  }
  .bp-selected-detail {
    font-size: 12px;
    line-height: 1.32;
  }
  .bp-selected-detail.density-compact {
    font-size: 11px;
    line-height: 1.22;
  }
  .bp-selected-detail.density-tight {
    font-size: 10px;
    line-height: 1.14;
  }
  .bp-selected-points {
    font-size: 20px;
  }
  .bp-selected-placeholder,
  .bp-actions-title,
  .bp-actions-state,
  .bp-btn,
  .bp-badge {
    font-size: 12px;
  }
  .bp-actions {
    padding: 10px;
    gap: 8px;
  }
  .bp-actions-state,
  .bp-btn {
    min-height: 42px;
  }
  .bp-track-wrapper {
    padding: 10px;
    gap: 8px;
  }
  .bp-track {
    gap: 8px;
  }
  .bp-card {
    flex: 0 0 calc((100% - 32px) / 5);
    width: calc((100% - 32px) / 5);
    padding: 8px;
    gap: 6px;
  }
  .bp-card-image {
    width: 84%;
    padding: 0;
  }
  .bp-card-pass-tag {
    top: 6px;
    right: 6px;
    min-height: 18px;
    padding: 0 6px;
    font-size: 8px;
  }
  .bp-card-level {
    padding: 3px 7px;
    gap: 4px;
  }
  .bp-card-level-label {
    font-size: 8px;
  }
  .bp-card-level-number {
    font-size: 10px;
  }
  .bp-card-title {
    font-size: 13px;
    min-height: 3.18em;
    max-height: 3.18em;
  }
  .bp-card-status {
    font-size: 10px;
  }
  .bp-card-points {
    font-size: 9px;
  }
  .bp-page-strip {
    min-width: 300px;
    max-width: 58vw;
    height: 34px;
    padding: 0 10px;
    gap: 6px;
  }
  .bp-page-dot {
    min-width: 24px;
    height: 24px;
    padding: 0 5px;
    font-size: 11px;
  }
  .bp-page-nav {
    width: 28px;
    height: 28px;
    font-size: 16px;
  }
}
@media (max-width: 760px) {
  .bp-track {
    overflow-x: auto;
  }
  .bp-card {
    flex: 0 0 180px;
    width: 180px;
  }
  .bp-card-image {
    width: 86%;
  }
  .bp-page-strip {
    min-width: 0;
    max-width: 62vw;
    justify-content: flex-start;
  }
  .bp-page-dot {
    min-width: 26px;
    height: 26px;
    padding: 0 6px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/bp/assets/style.less"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,kCAAA;EACA,0CAAA;EACA,qCAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EAEA,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,qCAAA;AAAJ;AAGA;;;EAGI,sBAAA;AADJ;AAIA;;;;;EAKI,wBAAA;EACA,gBAAA;EACA,wCAAA;AAFJ;AAKA;;;;;;;;EAQI,wBAAA;EACA,2BAAA;AAHJ;AAMA;EACI,kBAAA;EACA,QAAA;AAJJ;AAOA;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,kCAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AAQA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,yCAAA;EACA,sBAAA;AANJ;AASA;EACI,SAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAPJ;AAUA;EACI,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AARJ;AAWA;EACI,uBAAA;EACA,gBAAA;AATJ;AAYA;EACI,kCAAA;EACA,mBAAA;EACA,qCAAA;EACA,qBAAA;AAVJ;AAaA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,qBAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAXJ;AAcA;EACI,0BAAA;AAZJ;AAeA;EACI,WAAA;EACA,cAAA;EACA,oBAAA;EACA,qCAAA;EACA,gBAAA;AAbJ;AAgBA;EACI,YAAA;EACA,oBAAA;EACA,wEAAA;AAdJ;AAiBA;EACI,aAAA;EACA,oCAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;AAfJ;AAkBA;;;EAGI,kCAAA;EACA,mBAAA;EACA,qCAAA;AAhBJ;AAmBA;EACI,aAAA;EACA,gCAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAjBJ;AAoBA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAlBJ;AAqBA;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAnBJ;AAsBA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;AApBJ;AAuBA;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AArBJ;AAwBA;EACI,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;AAtBJ;AAyBA;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;AAvBJ;AA0BA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AAxBJ;AA2BA;EACI,mBAAA;AAzBJ;AA4BA;EACI,iBAAA;AA1BJ;AA6BA;EACI,QAAA;EACA,SAAA;AA3BJ;AA8BA;EACI,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AA5BJ;AA+BA;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AA7BJ;AAgCA;EACI,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9BJ;AAiCA;EACI,cAAA;EACA,qCAAA;EACA,uCAAA;AA/BJ;AAkCA;EACI,cAAA;EACA,mCAAA;EACA,qCAAA;AAhCJ;AAmCA;EACI,cAAA;EACA,oCAAA;EACA,qCAAA;AAjCJ;AAoCA;EACI,cAAA;EACA,kCAAA;EACA,qCAAA;AAlCJ;AAqCA;EACI,cAAA;EACA,qCAAA;EACA,uCAAA;AAnCJ;AAsCA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AApCJ;AAuCA;EACI,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AArCJ;AAwCA;EACI,iBAAA;EACA,kBAAA;EACA,2CAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAtCJ;AAyCA;EACI,cAAA;EACA,sCAAA;EACA,qCAAA;AAvCJ;AA0CA;EACI,cAAA;EACA,qCAAA;EACA,mCAAA;AAxCJ;AA2CA;EACI,cAAA;EACA,qCAAA;EACA,oCAAA;AAzCJ;AA4CA;EACI,cAAA;EACA,oCAAA;EACA,mCAAA;AA1CJ;AA6CA;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AA3CJ;AA8CA;EACI,kBAAA;EACA,oBAAA;AA5CJ;AA+CA;EACI,6DAAA;EACA,cAAA;EACA,oCAAA;AA7CJ;AAgDA;EACI,qCAAA;EACA,0BAAA;EACA,uCAAA;AA9CJ;AAiDA;EACI,OAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AA/CJ;AAkDA;EACI,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAhDJ;AAmDA;EACI,mCAAA;EACA,gCAAA;EACA,YAAA;EACA,qCAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AAjDJ;AAoDA;EACI,oCAAA;EACA,mCAAA;AAlDJ;AAqDA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnDJ;AAsDA;EACI,kBAAA;EACA,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;AApDJ;AAuDA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;AArDJ;AAwDA;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AAtDJ;AAyDA;EACI,cAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAvDJ;AA0DA;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAxDJ;AA2DA;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AAzDJ;AA4DA;EACI,2BAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AA1DJ;AA6DA;EACI,WAAA;EACA,cAAA;EACA,oBAAA;EACA,qCAAA;EACA,gBAAA;AA3DJ;AA8DA;EACI,YAAA;EACA,oBAAA;EACA,oDAAA;AA5DJ;AA+DA;EACI,oDAAA;AA7DJ;AAgEA;EACI,oDAAA;AA9DJ;AAiEA;EACI,oDAAA;AA/DJ;AAkEA;EACI,oDAAA;AAhEJ;AAmEA;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjEJ;AAoEA;EACI,iBAAA;EACA,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAlEJ;AAqEA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;EACA,qCAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAnEJ;AAsEA;EACI,aAAA;EACA,eAAA;AApEJ;AAuEA;EACI,eAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,2CAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AArEJ;AAwEA;;EAEI,QAAA;EACA,SAAA;AAtEJ;AAyEA;EACI,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,2CAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAvEJ;AA0EA;EACI,oCAAA;EACA,mBAAA;EACA,cAAA;AAxEJ;AA2EA;EACI;IACI,WAAA;IACA,YAAA;IACA,8BAAA;IACA,aAAA;IACA,SAAA;EAzEN;EA4EE;IACI,gBAAA;IACA,mBAAA;EA1EN;EA6EE;IACI,mCAAA;EA3EN;EA8EE;IACI,oCAAA;EA5EN;EA+EE;IACI,kBAAA;EA7EN;EAgFE;IACI,oCAAA;IACA,kBAAA;EA9EN;EAiFE;IACI,kBAAA;IACA,cAAA;IACA,SAAA;EA/EN;EAkFE;IACI,gCAAA;IACA,aAAA;IACA,SAAA;EAhFN;EAmFE;IACI,cAAA;IACA,eAAA;EAjFN;EAoFE;IACI,oCAAA;IACA,iBAAA;IACA,QAAA;IACA,kBAAA;IACA,qBAAA;EAlFN;EAqFE;IACI,aAAA;IACA,QAAA;EAnFN;EAsFE;IACI,oCAAA;EApFN;EAuFE;IACI,gBAAA;IACA,oCAAA;IACA,eAAA;EArFN;EAwFE;IACI,gBAAA;IACA,oCAAA;EAtFN;EAyFE;IACI,aAAA;IACA,QAAA;EAvFN;EA0FE;IACI,uBAAA;EAxFN;EA2FE;IACI,eAAA;IACA,YAAA;IACA,YAAA;IACA,QAAA;EAzFN;EA4FE;IACI,UAAA;IACA,gBAAA;IACA,iBAAA;EA1FN;EA6FE;IACI,gBAAA;EA3FN;EA8FE;IACI,oCAAA;EA5FN;EA+FE;IACI,oCAAA;EA7FN;EAgGE;IACI,oCAAA;EA9FN;EAiGE;IACI,gBAAA;IACA,gBAAA;EA/FN;EAkGE;IACI,WAAA;IACA,YAAA;IACA,eAAA;EAhGN;EAmGE;IACI,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,QAAA;IACA,eAAA;EAjGN;EAoGE;IACI,eAAA;IACA,YAAA;IACA,eAAA;IACA,cAAA;EAlGN;AACF;AAqGA;EACI;IACI,WAAA;IACA,YAAA;IACA,eAAA;EAnGN;EAsGE;IACI,gBAAA;EApGN;EAuGE;IACI,gBAAA;EArGN;EAwGE;IACI,cAAA;EAtGN;EAyGE;IACI,gCAAA;IACA,kBAAA;IACA,cAAA;EAvGN;EA0GE;IACI,gCAAA;EAxGN;EA2GE;IACI,cAAA;EAzGN;EA4GE;IACI,iBAAA;EA1GN;EA6GE;IACI,iBAAA;EA3GN;EA8GE;IACI,gBAAA;EA5GN;EA+GE;IACI,iBAAA;EA7GN;EAgHE;;;;;IAKI,iBAAA;EA9GN;EAiHE;IACI,cAAA;IACA,kBAAA;IACA,kBAAA;EA/GN;EAkHE;IACI,iBAAA;EAhHN;EAmHE;IACI,iBAAA;EAjHN;EAoHE;IACI,gBAAA;IACA,aAAA;IACA,iBAAA;IACA,iBAAA;EAlHN;EAqHE;IACI,YAAA;IACA,aAAA;IACA,iBAAA;EAnHN;AACF;AAsHA;EACI;IACI,WAAA;IACA,YAAA;IACA,aAAA;IACA,SAAA;EApHN;EAuHE;IACI,gBAAA;IACA,mBAAA;EArHN;EAwHE;IACI,eAAA;EAtHN;EAyHE;IACI,eAAA;EAvHN;EA0HE;IACI,kBAAA;EAxHN;EA2HE;IACI,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,kBAAA;IACA,eAAA;EAzHN;EA4HE;IACI,0BAAA;IACA,YAAA;EA1HN;EA6HE;IACI,gCAAA;IACA,iBAAA;IACA,aAAA;IACA,SAAA;EA3HN;EA8HE;IACI,eAAA;IACA,mBAAA;EA5HN;EA+HE;IACI,eAAA;IACA,iBAAA;EA7HN;EAgIE;IACI,eAAA;IACA,iBAAA;EA9HN;EAiIE;IACI,eAAA;IACA,iBAAA;EA/HN;EAkIE;IACI,eAAA;EAhIN;EAmIE;;;;;IAKI,eAAA;EAjIN;EAoIE;IACI,aAAA;IACA,QAAA;EAlIN;EAqIE;;IAEI,gBAAA;EAnIN;EAsIE;IACI,aAAA;IACA,QAAA;EApIN;EAuIE;IACI,QAAA;EArIN;EAwIE;IACI,iCAAA;IACA,8BAAA;IACA,YAAA;IACA,QAAA;EAtIN;EAyIE;IACI,UAAA;IACA,UAAA;EAvIN;EA0IE;IACI,QAAA;IACA,UAAA;IACA,gBAAA;IACA,cAAA;IACA,cAAA;EAxIN;EA2IE;IACI,gBAAA;IACA,QAAA;EAzIN;EA4IE;IACI,cAAA;EA1IN;EA6IE;IACI,eAAA;EA3IN;EA8IE;IACI,eAAA;IACA,kBAAA;IACA,kBAAA;EA5IN;EA+IE;IACI,eAAA;EA7IN;EAgJE;IACI,cAAA;EA9IN;EAiJE;IACI,gBAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;IACA,QAAA;EA/IN;EAkJE;IACI,eAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;EAhJN;EAmJE;IACI,WAAA;IACA,YAAA;IACA,eAAA;EAjJN;AACF;AAoJA;EACI;IACI,gBAAA;EAlJN;EAqJE;IACI,eAAA;IACA,YAAA;EAnJN;EAsJE;IACI,UAAA;EApJN;EAuJE;IACI,YAAA;IACA,eAAA;IACA,2BAAA;EArJN;EAwJE;IACI,eAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;EAtJN;AACF","sourcesContent":[".bp-root {\n    --bp-bg: rgba(0, 0, 0, 0.7);\n    --bp-panel: rgba(16, 16, 16, 0.96);\n    --bp-panel-soft: rgba(255, 255, 255, 0.05);\n    --bp-border: rgba(255, 255, 255, 0.1);\n    --bp-text-main: #f2f2f2;\n    --bp-text-muted: #a6a6a6;\n    --bp-accent: #ffcc00;\n    --bp-accent-2: #f59e0b;\n\n    position: fixed;\n    inset: 0;\n    z-index: 1900;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--bp-bg);\n    color: var(--bp-text-main);\n    font-family: 'TT Commons', sans-serif;\n}\n\n.bp-root *,\n.bp-root *::before,\n.bp-root *::after {\n    box-sizing: border-box;\n}\n\n.bp-root button,\n.bp-root [type=\"button\"],\n.bp-root .bp-card,\n.bp-root .bp-page-dot,\n.bp-root .bp-page-nav {\n    outline: none !important;\n    box-shadow: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.bp-root button:focus,\n.bp-root button:focus-visible,\n.bp-root .bp-card:focus,\n.bp-root .bp-card:focus-visible,\n.bp-root .bp-page-dot:focus,\n.bp-root .bp-page-dot:focus-visible,\n.bp-root .bp-page-nav:focus,\n.bp-root .bp-page-nav:focus-visible {\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n.bp-backdrop {\n    position: absolute;\n    inset: 0;\n}\n\n.bp-shell {\n    width: 78vw;\n    height: 76vh;\n    background: var(--bp-panel);\n    border-radius: 12px;\n    border: 1px solid var(--bp-border);\n    box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);\n    padding: 0.75vw;\n    display: flex;\n    flex-direction: column;\n    gap: 0.6vw;\n    overflow: hidden;\n    position: relative;\n}\n\n.bp-header {\n    min-height: 5.1vh;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1vw;\n    border-bottom: 1px solid var(--bp-border);\n    padding-bottom: 0.35vw;\n}\n\n.bp-header h1 {\n    margin: 0;\n    font-size: 2.15vw;\n    line-height: 1;\n    font-weight: 900;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n\n.bp-days {\n    color: var(--bp-text-muted);\n    font-size: 1.25vw;\n    font-weight: 800;\n    text-transform: uppercase;\n    white-space: nowrap;\n}\n\n.bp-days span {\n    color: var(--bp-accent);\n    font-weight: 900;\n}\n\n.bp-season-progress {\n    border: 1px solid var(--bp-border);\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.02);\n    padding: 0.45vw 0.6vw;\n}\n\n.bp-season-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1vw;\n    margin-bottom: 0.28vw;\n    color: var(--bp-text-muted);\n    font-size: 0.75vw;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n.bp-season-value {\n    color: var(--bp-text-main);\n}\n\n.bp-season-track {\n    width: 100%;\n    height: 0.78vh;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.12);\n    overflow: hidden;\n}\n\n.bp-season-fill {\n    height: 100%;\n    border-radius: 999px;\n    background: linear-gradient(90deg, var(--bp-accent), var(--bp-accent-2));\n}\n\n.bp-content {\n    display: grid;\n    grid-template-columns: 1.75fr 0.95fr;\n    gap: 0.6vw;\n    min-height: 15.5vh;\n    height: 15.5vh;\n    align-items: stretch;\n}\n\n.bp-selected,\n.bp-actions,\n.bp-track-wrapper {\n    border: 1px solid var(--bp-border);\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.02);\n}\n\n.bp-selected {\n    display: grid;\n    grid-template-columns: 7.2vw 1fr;\n    gap: 0.82vw;\n    padding: 0.5vw;\n    min-width: 0;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.bp-selected-image {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n    overflow: visible;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n}\n\n.bp-selected-image img {\n    max-width: 76%;\n    max-height: 76%;\n    width: auto;\n    height: auto;\n    object-fit: contain;\n    object-position: center;\n    display: block;\n    margin: 0 auto;\n}\n\n.bp-selected-info {\n    min-width: 0;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 0.36vw;\n    padding-top: 0.08vw;\n}\n\n.bp-selected-title {\n    font-size: 1.78vw;\n    font-weight: 900;\n    line-height: 1.02;\n    max-width: 100%;\n    white-space: normal;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n}\n\n.bp-selected-detail {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.16vw;\n    color: var(--bp-text-main);\n    font-size: 0.82vw;\n    font-weight: 700;\n    line-height: 1.28;\n    overflow: auto;\n    padding-right: 0.22vw;\n    scrollbar-width: none;\n}\n\n.bp-selected-detail.density-compact {\n    gap: 0.12vw;\n    font-size: 0.75vw;\n    line-height: 1.2;\n}\n\n.bp-selected-detail.density-tight {\n    gap: 0.08vw;\n    font-size: 0.68vw;\n    line-height: 1.12;\n}\n\n.bp-selected-detail-line {\n    white-space: normal;\n}\n\n.bp-selected-detail-line.is-empty {\n    min-height: 0.6em;\n}\n\n.bp-selected-detail::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n}\n\n.bp-selected-placeholder {\n    color: var(--bp-text-muted);\n    font-size: 0.76vw;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.bp-selected-points {\n    font-size: 1.42vw;\n    font-weight: 800;\n    color: var(--bp-accent);\n    line-height: 1;\n}\n\n.bp-badge {\n    width: fit-content;\n    max-width: 100%;\n    padding: 0.22vw 0.65vw;\n    border-radius: 999px;\n    border: 1px solid transparent;\n    font-size: 0.72vw;\n    font-weight: 900;\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.bp-badge.state-claim {\n    color: #ffd8ff;\n    background: rgba(217, 102, 255, 0.22);\n    border-color: rgba(217, 102, 255, 0.45);\n}\n\n.bp-badge.state-done {\n    color: #ceffd6;\n    background: rgba(76, 175, 80, 0.22);\n    border-color: rgba(76, 175, 80, 0.45);\n}\n\n.bp-badge.state-vip {\n    color: #ffe0b0;\n    background: rgba(255, 159, 26, 0.22);\n    border-color: rgba(255, 159, 26, 0.5);\n}\n\n.bp-badge.state-open {\n    color: #ffe7ab;\n    background: rgba(255, 204, 0, 0.2);\n    border-color: rgba(255, 204, 0, 0.45);\n}\n\n.bp-badge.state-locked {\n    color: #d8d8d8;\n    background: rgba(255, 255, 255, 0.14);\n    border-color: rgba(255, 255, 255, 0.28);\n}\n\n.bp-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35vw;\n    padding: 0.5vw;\n    min-width: 0;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.bp-actions-title {\n    color: var(--bp-text-muted);\n    font-size: 0.72vw;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n.bp-actions-state {\n    min-height: 3.4vh;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.28);\n    background: rgba(255, 255, 255, 0.08);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 0.5vw;\n    font-size: 0.92vw;\n    font-weight: 900;\n    text-transform: uppercase;\n    text-align: center;\n}\n\n.bp-actions-state.state-claim {\n    color: #ffd8ff;\n    border-color: rgba(217, 102, 255, 0.5);\n    background: rgba(217, 102, 255, 0.22);\n}\n\n.bp-actions-state.state-done {\n    color: #ceffd6;\n    border-color: rgba(76, 175, 80, 0.55);\n    background: rgba(76, 175, 80, 0.22);\n}\n\n.bp-actions-state.state-vip {\n    color: #ffe0b0;\n    border-color: rgba(255, 159, 26, 0.6);\n    background: rgba(255, 159, 26, 0.24);\n}\n\n.bp-actions-state.state-open {\n    color: #ffe7ab;\n    border-color: rgba(255, 204, 0, 0.6);\n    background: rgba(255, 204, 0, 0.22);\n}\n\n.bp-btn {\n    min-height: 3.35vh;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    font-size: 0.96vw;\n    font-weight: 900;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n\n.bp-btn-placeholder {\n    visibility: hidden;\n    pointer-events: none;\n}\n\n.bp-btn-primary {\n    background: linear-gradient(135deg, #ffcc00 0%, #f59e0b 100%);\n    color: #1a1a1a;\n    border-color: rgba(255, 204, 0, 0.5);\n}\n\n.bp-btn-secondary {\n    background: rgba(255, 255, 255, 0.08);\n    color: var(--bp-text-main);\n    border-color: rgba(255, 255, 255, 0.22);\n}\n\n.bp-track-wrapper {\n    flex: 1;\n    min-height: 0;\n    padding: 0.45vw;\n    display: flex;\n    flex-direction: column;\n    gap: 0.38vw;\n}\n\n.bp-track {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    gap: 0.42vw;\n    overflow: hidden;\n}\n\n.bp-card {\n    flex: 0 0 calc((100% - 1.68vw) / 5);\n    width: calc((100% - 1.68vw) / 5);\n    min-width: 0;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid var(--bp-border);\n    border-radius: 8px;\n    padding: 0.38vw;\n    display: flex;\n    flex-direction: column;\n    gap: 0.24vw;\n    position: relative;\n    text-align: left;\n    color: var(--bp-text-main);\n    cursor: pointer;\n    overflow: hidden;\n}\n\n.bp-card.is-selected {\n    border-color: rgba(255, 204, 0, 0.8);\n    background: rgba(255, 204, 0, 0.08);\n}\n\n.bp-card-pass-tag {\n    position: absolute;\n    top: 0.3vw;\n    right: 0.3vw;\n    min-height: 1.5vh;\n    padding: 0 0.32vw;\n    border-radius: 999px;\n    background: rgba(255, 159, 26, 0.92);\n    color: #171717;\n    font-size: 0.45vw;\n    font-weight: 900;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.bp-card-level {\n    width: fit-content;\n    max-width: calc(100% - 2.8vw);\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.15);\n    color: #fff;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.18vw;\n    padding: 0.16vw 0.34vw;\n    text-transform: uppercase;\n}\n\n.bp-card-level-label {\n    opacity: 0.72;\n    font-size: 0.46vw;\n    font-weight: 800;\n}\n\n.bp-card-level-number {\n    font-size: 0.62vw;\n    font-weight: 900;\n    line-height: 1;\n}\n\n.bp-card-image {\n    flex: 0 0 auto;\n    width: 82%;\n    aspect-ratio: 1 / 1;\n    min-height: 0;\n    border-radius: 0;\n    overflow: visible;\n    background: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-self: center;\n    padding: 0;\n    margin: 0 auto;\n}\n\n.bp-card-image img {\n    max-width: 76%;\n    max-height: 76%;\n    width: auto;\n    height: auto;\n    object-fit: contain;\n    object-position: center;\n    display: block;\n    margin: 0 auto;\n}\n\n.bp-card-title {\n    font-size: 0.84vw;\n    font-weight: 800;\n    line-height: 1.06;\n    min-height: 3.18em;\n    max-height: 3.18em;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 3;\n}\n\n.bp-card-status {\n    color: var(--bp-text-muted);\n    font-size: 0.62vw;\n    text-transform: uppercase;\n    line-height: 1.05;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.bp-card-track {\n    width: 100%;\n    height: 0.65vh;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.14);\n    overflow: hidden;\n}\n\n.bp-card-track div {\n    height: 100%;\n    border-radius: 999px;\n    background: linear-gradient(90deg, #ffcc00, #f59e0b);\n}\n\n.bp-card.state-claim .bp-card-track div {\n    background: linear-gradient(90deg, #d966ff, #f1b8ff);\n}\n\n.bp-card.state-done .bp-card-track div {\n    background: linear-gradient(90deg, #4caf50, #81db84);\n}\n\n.bp-card.state-vip .bp-card-track div {\n    background: linear-gradient(90deg, #ff9f1a, #ffd08c);\n}\n\n.bp-card.state-locked .bp-card-track div {\n    background: linear-gradient(90deg, #7e7e7e, #b3b3b3);\n}\n\n.bp-card-points {\n    font-size: 0.48vw;\n    color: #e1e1e1;\n    font-weight: 700;\n    line-height: 1.12;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.bp-pagination {\n    min-height: 3.4vh;\n    border-top: 1px solid var(--bp-border);\n    padding-top: 0.22vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.45vw;\n}\n\n.bp-page-nav {\n    width: 1.7vw;\n    height: 1.7vw;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    background: rgba(255, 255, 255, 0.06);\n    color: #fff;\n    font-size: 0.95vw;\n    line-height: 1;\n    cursor: pointer;\n    flex: 0 0 auto;\n}\n\n.bp-page-nav:disabled {\n    opacity: 0.35;\n    cursor: default;\n}\n\n.bp-page-strip {\n    min-width: 26vw;\n    max-width: 36vw;\n    height: 2.15vw;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    background: rgba(0, 0, 0, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.3vw;\n    padding: 0 0.7vw;\n    overflow-x: auto;\n    scrollbar-width: none;\n}\n\n.bp-page-strip::-webkit-scrollbar,\n.bp-track::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n}\n\n.bp-page-dot {\n    min-width: 1.22vw;\n    height: 1.22vw;\n    padding: 0 0.26vw;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.26);\n    background: rgba(255, 255, 255, 0.05);\n    color: #d0d0d0;\n    font-size: 0.58vw;\n    font-weight: 800;\n    cursor: pointer;\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1;\n}\n\n.bp-page-dot.is-active {\n    border-color: rgba(255, 204, 0, 0.8);\n    background: #ffcc00;\n    color: #151515;\n}\n\n@media (min-width: 2560px) and (min-aspect-ratio: 21 / 9) {\n    .bp-shell {\n        width: 84vw;\n        height: 80vh;\n        max-height: calc(100vh - 32px);\n        padding: 14px;\n        gap: 10px;\n    }\n\n    .bp-header {\n        min-height: 76px;\n        padding-bottom: 8px;\n    }\n\n    .bp-header h1 {\n        font-size: clamp(42px, 1.9vw, 64px);\n    }\n\n    .bp-days {\n        font-size: clamp(26px, 1.05vw, 38px);\n    }\n\n    .bp-season-progress {\n        padding: 10px 14px;\n    }\n\n    .bp-season-top {\n        font-size: clamp(14px, 0.52vw, 20px);\n        margin-bottom: 7px;\n    }\n\n    .bp-content {\n        min-height: 18.2vh;\n        height: 18.2vh;\n        gap: 10px;\n    }\n\n    .bp-selected {\n        grid-template-columns: 170px 1fr;\n        padding: 12px;\n        gap: 12px;\n    }\n\n    .bp-selected-image img {\n        max-width: 82%;\n        max-height: 82%;\n    }\n\n    .bp-selected-detail {\n        font-size: clamp(14px, 0.48vw, 20px);\n        line-height: 1.24;\n        gap: 4px;\n        padding-right: 8px;\n        scrollbar-width: thin;\n    }\n\n    .bp-actions {\n        padding: 12px;\n        gap: 8px;\n    }\n\n    .bp-actions-title {\n        font-size: clamp(13px, 0.45vw, 18px);\n    }\n\n    .bp-actions-state {\n        min-height: 58px;\n        font-size: clamp(22px, 0.74vw, 32px);\n        padding: 0 12px;\n    }\n\n    .bp-btn {\n        min-height: 58px;\n        font-size: clamp(24px, 0.78vw, 34px);\n    }\n\n    .bp-track-wrapper {\n        padding: 10px;\n        gap: 8px;\n    }\n\n    .bp-track {\n        justify-content: center;\n    }\n\n    .bp-card {\n        flex: 0 0 min(calc((100% - 48px) / 5), 320px);\n        width: min(calc((100% - 48px) / 5), 320px);\n        padding: 8px;\n        gap: 6px;\n    }\n\n    .bp-card-image {\n        width: 72%;\n        max-width: 180px;\n        max-height: 180px;\n    }\n\n    .bp-card-track {\n        margin-top: auto;\n    }\n\n    .bp-card-title {\n        font-size: clamp(16px, 0.56vw, 22px);\n    }\n\n    .bp-card-status {\n        font-size: clamp(11px, 0.38vw, 15px);\n    }\n\n    .bp-card-points {\n        font-size: clamp(10px, 0.34vw, 14px);\n    }\n\n    .bp-pagination {\n        min-height: 58px;\n        padding-top: 6px;\n    }\n\n    .bp-page-nav {\n        width: 40px;\n        height: 40px;\n        font-size: 24px;\n    }\n\n    .bp-page-strip {\n        height: 48px;\n        min-width: 560px;\n        max-width: 860px;\n        gap: 8px;\n        padding: 0 14px;\n    }\n\n    .bp-page-dot {\n        min-width: 32px;\n        height: 32px;\n        font-size: 16px;\n        padding: 0 8px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .bp-shell {\n        width: 88vw;\n        height: 80vh;\n        padding: 0.85vw;\n    }\n\n    .bp-header h1 {\n        font-size: 2.8vw;\n    }\n\n    .bp-days {\n        font-size: 1.6vw;\n    }\n\n    .bp-season-top {\n        font-size: 1vw;\n    }\n\n    .bp-content {\n        grid-template-columns: 1.4fr 1fr;\n        min-height: 16.5vh;\n        height: 16.5vh;\n    }\n\n    .bp-selected {\n        grid-template-columns: 8.8vw 1fr;\n    }\n\n    .bp-selected-title {\n        font-size: 2vw;\n    }\n\n    .bp-selected-detail {\n        font-size: 0.98vw;\n    }\n\n    .bp-selected-detail.density-compact {\n        font-size: 0.88vw;\n    }\n\n    .bp-selected-detail.density-tight {\n        font-size: 0.8vw;\n    }\n\n    .bp-selected-points {\n        font-size: 1.55vw;\n    }\n\n    .bp-selected-placeholder,\n    .bp-badge,\n    .bp-actions-title,\n    .bp-actions-state,\n    .bp-btn {\n        font-size: 0.95vw;\n    }\n\n    .bp-card-title {\n        font-size: 1vw;\n        min-height: 3.18em;\n        max-height: 3.18em;\n    }\n\n    .bp-card-status {\n        font-size: 0.78vw;\n    }\n\n    .bp-card-points {\n        font-size: 0.62vw;\n    }\n\n    .bp-page-dot {\n        min-width: 1.9vw;\n        height: 1.7vw;\n        padding: 0 0.34vw;\n        font-size: 0.85vw;\n    }\n\n    .bp-page-nav {\n        width: 2.2vw;\n        height: 2.2vw;\n        font-size: 1.25vw;\n    }\n}\n\n@media (max-width: 980px) {\n    .bp-shell {\n        width: 94vw;\n        height: 86vh;\n        padding: 10px;\n        gap: 10px;\n    }\n\n    .bp-header {\n        min-height: 46px;\n        padding-bottom: 6px;\n    }\n\n    .bp-header h1 {\n        font-size: 32px;\n    }\n\n    .bp-days {\n        font-size: 18px;\n    }\n\n    .bp-season-progress {\n        padding: 10px 12px;\n    }\n\n    .bp-season-top {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 6px;\n        margin-bottom: 6px;\n        font-size: 12px;\n    }\n\n    .bp-content {\n        grid-template-columns: 1fr;\n        height: auto;\n    }\n\n    .bp-selected {\n        grid-template-columns: 132px 1fr;\n        min-height: 130px;\n        padding: 10px;\n        gap: 10px;\n    }\n\n    .bp-selected-title {\n        font-size: 24px;\n        white-space: normal;\n    }\n\n    .bp-selected-detail {\n        font-size: 12px;\n        line-height: 1.32;\n    }\n\n    .bp-selected-detail.density-compact {\n        font-size: 11px;\n        line-height: 1.22;\n    }\n\n    .bp-selected-detail.density-tight {\n        font-size: 10px;\n        line-height: 1.14;\n    }\n\n    .bp-selected-points {\n        font-size: 20px;\n    }\n\n    .bp-selected-placeholder,\n    .bp-actions-title,\n    .bp-actions-state,\n    .bp-btn,\n    .bp-badge {\n        font-size: 12px;\n    }\n\n    .bp-actions {\n        padding: 10px;\n        gap: 8px;\n    }\n\n    .bp-actions-state,\n    .bp-btn {\n        min-height: 42px;\n    }\n\n    .bp-track-wrapper {\n        padding: 10px;\n        gap: 8px;\n    }\n\n    .bp-track {\n        gap: 8px;\n    }\n\n    .bp-card {\n        flex: 0 0 calc((100% - 32px) / 5);\n        width: calc((100% - 32px) / 5);\n        padding: 8px;\n        gap: 6px;\n    }\n\n    .bp-card-image {\n        width: 84%;\n        padding: 0;\n    }\n\n    .bp-card-pass-tag {\n        top: 6px;\n        right: 6px;\n        min-height: 18px;\n        padding: 0 6px;\n        font-size: 8px;\n    }\n\n    .bp-card-level {\n        padding: 3px 7px;\n        gap: 4px;\n    }\n\n    .bp-card-level-label {\n        font-size: 8px;\n    }\n\n    .bp-card-level-number {\n        font-size: 10px;\n    }\n\n    .bp-card-title {\n        font-size: 13px;\n        min-height: 3.18em;\n        max-height: 3.18em;\n    }\n\n    .bp-card-status {\n        font-size: 10px;\n    }\n\n    .bp-card-points {\n        font-size: 9px;\n    }\n\n    .bp-page-strip {\n        min-width: 300px;\n        max-width: 58vw;\n        height: 34px;\n        padding: 0 10px;\n        gap: 6px;\n    }\n\n    .bp-page-dot {\n        min-width: 24px;\n        height: 24px;\n        padding: 0 5px;\n        font-size: 11px;\n    }\n\n    .bp-page-nav {\n        width: 28px;\n        height: 28px;\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 760px) {\n    .bp-track {\n        overflow-x: auto;\n    }\n\n    .bp-card {\n        flex: 0 0 180px;\n        width: 180px;\n    }\n\n    .bp-card-image {\n        width: 86%;\n    }\n\n    .bp-page-strip {\n        min-width: 0;\n        max-width: 62vw;\n        justify-content: flex-start;\n    }\n\n    .bp-page-dot {\n        min-width: 26px;\n        height: 26px;\n        padding: 0 6px;\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
